import(/* webpackMode: "eager" */ "/var/www/bhq-nextjs/src/app/[locale]/not-found.js");
